import { useCallback } from 'react';
import { ErrorTypes } from 'src/contexts/ClientLogContext';
import { useContent } from 'src/contexts/ContentContext';
import { ContentId } from 'src/utils/constants/contentId';
import { tryInvokeApi } from 'src/utils/tryExecuteUtils';
import { LoginClient, LoginContext } from 'src/WebApiController';

export const useFetchLoginContext = () => {
  const loginErrorMessage = useContent(
    ContentId.Error_Unauthorized_GenericMessage
  );
  const fetchLoginContext = useCallback(
    async (
      onSuccess: (loginContext: LoginContext) => void,
      onError?: (error: ErrorTypes) => void
    ) => {
      return await tryInvokeApi(
        async () => {
          const loginContext = await new LoginClient({}).getLoginContext(
            window.location.pathname
          );

          if (
            loginContext.isSuccess &&
            loginContext?.user?.activeAccount?.id != null
          ) {
            onSuccess(loginContext);
            return loginContext;
          } else {
            onError?.({
              status: 401,
              message: loginErrorMessage,
              response: JSON.stringify(loginContext),
            });
            return undefined;
          }
        },
        (error) => {
          onError?.(error);
        }
      );
    },
    [loginErrorMessage]
  );

  return {
    fetchLoginContext,
  };
};
